import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

export const getCurrentSeason = (currentDate = dayjs()): [Dayjs, Dayjs] => {
  const currentYear = currentDate.year();
  let start, end;
  if (currentDate.month() >= 6) {
    start = dayjs(`${currentYear}-07-01`);
    end = dayjs(`${currentYear + 1}-06-30`);
  } else {
    start = dayjs(`${currentYear - 1}-07-01`);
    end = dayjs(`${currentYear}-06-30`);
  }
  start = start.startOf('day');
  end = end.endOf('day');

  return [start, end];
};

export const getCurrentSeasonString = ([start, end] = getCurrentSeason()) => {
  return `${start.year()}/${end.year().toString().slice(2)}`;
};

export const isDateInCurrentSeason = (boardingDate: string, currentDate?: Dayjs) => {
  const [seasonStart, seasonEnd] = getCurrentSeason(currentDate);

  if (
    (dayjs(boardingDate).isAfter(seasonStart) || dayjs(boardingDate).isSame(seasonStart))
    && (dayjs(boardingDate).isBefore(seasonEnd) || dayjs(boardingDate).isSame(seasonEnd))
  ) {
    return 1;
  } else {
    return 0;
  }
};

export const getSeasonForDate = (date: Date = new Date()) => {
  const year = dayjs(date).year();
  const month = dayjs(date).month();

  let seasonStartYear;
  let seasonEndYear;

  if (month >= 6) {
    seasonStartYear = year;
    seasonEndYear = year + 1;
  } else {
    seasonStartYear = year - 1;
    seasonEndYear = year;
  }

  return `${seasonStartYear}/${seasonEndYear}`;
};

export const getSeasonsArray = (currentDate = dayjs()) => {
  const currentYear = currentDate.year();
  const currentMonth = currentDate.month();

  let seasonStartYear;
  if (currentMonth >= 6) {
    seasonStartYear = currentYear;
  } else {
    seasonStartYear = currentYear - 1;
  }

  const seasons = [];
  for (let i = 0; i <= 10; i++) {
    const startYear = seasonStartYear - i;
    const endYear = startYear + 1;
    const season = `${startYear}/${endYear}`;
    seasons.push({ value: season, label: season });
  }

  return seasons;
};
